const menubtn = ( function () {
    const btn = document.querySelector('.menubtn');
    const link = document.querySelectorAll('.menubtn__str > .menubtn__item');

    function toggleMenu() {
        btn.classList.toggle('menu-expanded');
    }
    btn.addEventListener('click', toggleMenu);

    for (var i=0; i < link.length; ++i){
        link[i].addEventListener('click', function(){
            event.preventDefault();
            var name = this.getAttribute('href').slice(1);
            var cords = getCoords(document.getElementById(name));

            scrollToTop(1000, cords);
        });
    }

    function getCoords(elem) {
        const box = elem.getBoundingClientRect();

        return {
          top: box.top + pageYOffset,
          left: box.left + pageXOffset
        };

      }
    function scrollToTop(scrollDuration, coords) {
        var scrollStep = (coords.top - window.scrollY) / (scrollDuration / 15),
            scrollInterval = setInterval(function(){
            if (Math.abs( window.scrollY -coords.top) > 20) {
                window.scrollBy( 0, scrollStep );
            }
            else
            {
                window.scrollBy( 0, coords.top - window.scrollY);
                clearInterval(scrollInterval);
            }
        },15);
    }
});


module.exports = menubtn;



// WEBPACK FOOTER //
// ./app/blocks/menubtn/menubtn.js